
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
  STUDENT_DETAILS_ACTION,
  GET_STUDENT_DETAILS,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';


export const getStudentDetails = (start, end) => async (dispatch) => {  

  var payload = {
    "startdate": start,
    "enddate":end
  }
  dispatch({ type: STUDENT_DETAILS_ACTION });
  axios.post(AppConfig.apiurl + '/api/studentfulldownload', payload, { headers: AuthHeader.header })
  .then(response => {
    const alldata = response.data.data;
    dispatch({ type: GET_STUDENT_DETAILS, payload: alldata });
  });

}
